const selectScienceReviewsMapping = {
    "/products/direct-zol-rna-miniprep-plus-kits": 205593,
    "/products/zymobiomics-dna-miniprep-kit": 206029,
    "/products/zymopure-ii-plasmid-maxiprep-kit": 205859,
    "/products/dna-rna-shield": 205890,
    "/products/quick-rna-miniprep-plus-kit": 205865,
    "/products/15-ml-conical-reservoir":	225763,
    "/products/5-mc-dna-elisa-kit":	205873,
    "/products/bisulfite-converted-universal-methylated-human-dna-standard":	225479,
    "/products/chip-dna-clean-concentrator":	205872,
    "/products/collection-tubes":	217422,
    "/products/dna-binding-buffer":	220518,
    "/products/dna-clean-concentrator-25":	205879,
    "/products/dna-clean-concentrator-5":	205878,
    "/products/dna-degradase-plus":	214298,
    "/products/dna-rna-shield-blood-collection-tube":	214321,
    "/products/dna-rna-shield-fecal-collection-tube":	214319,
    "/products/dna-rna-shield-saliva-collection-kit":	214323,
    "/products/dna-rna-shield-collection-tube-w-swab":	214320,
    "/products/direct-zol-dna-rna-miniprep":	214338,
    "/products/direct-zol-rna-microprep-kits":	214330,
    "/products/direct-zol-rna-miniprep-kits":	171899,
    "/products/ez-dna-methylation-direct-kit":	205868,
    "/products/ez-dna-methylation-gold-kit":	205867,
    "/products/ez-dna-methylation-lightning-kit":	205869,
    "/products/ez-dna-methylation-startup-kit":	219594,
    "/products/ez-dna-methylation-kit":	205866,
    "/products/ez-rna-methylation-kit":	214331,
    "/products/ez-96-dna-methylation-kit":	217249,
    "/products/femto-bacterial-dna-quantification-kit":	205838,
    "/products/femto-fungal-dna-quantification-kit":	205839,
    "/products/femto-human-dna-quantification-kit":	205837,
    "/products/frozen-ez-yeast-transformation-ii-kit":	214332,
    "/products/genomic-dna-clean-concentrator-10":	205880,
    "/products/genomic-dna-clean-concentrator-25":	205881,
    "/products/his-spin-protein-miniprep":	214309,
    "/products/hostzero-sup-trade-sup-microbial-dna-kit-microprep":	214295,
    "/products/mbp-spin-protein-miniprep":	214311,
    "/products/mix-and-go-competent-cells-dh5-alpha":	224112,
    "/products/mix-and-go-competent-cells-xja-autolysis":	214335,
    "/products/mix-and-go-competent-cells-xjb-autolysis":	214337,
    "/products/mix-and-go-competent-cells-jm109":	214333,
    "/products/mix-and-go-competent-cells-zymo-10b":	214334,
    "/products/mix-and-go-e-coli-transformation-kit":	205882,
    "/products/mix-and-go-competent-cells-zymo-5a":	205883,
    "/products/oligo-clean-concentrator":	214290,
    "/products/onestep-pcr-inhibitor-removal-kit":	205895,
    "/products/pcr-strip-magstand":	224844,
    "/products/pico-methyl-seq-library-prep-kit":	205870,
    "/products/proteinase-k-w-storage-buffer-set":	217131,
    "/products/quest-5-hmc-dna-elisa-kit":	205874,
    "/products/quick-covid-19-antibody-detection-kit":	224055,
    "/products/quick-rna-viral-kit":	214315,
    "/products/quick-sars-cov-2-multiplex-kit":	224024,
    "/products/quick-sars-cov-2-rrt-pcr-kit":	223937,
    "/products/quick-16s-ngs-library-prep-kit":	214305,
    "/products/quick-dna-hmw-magbead-kit":  225953,
    "/products/quick-dna-rna-miniprep":	210079,
    "/products/quick-dna-rna-viral-magbead":	224047,
    "/products/quick-dna-rna-blood-tube-kit":	214322,
    "/products/quick-dna-rna-ffpe-miniprep-kit":	214313,
    "/products/quick-dna-rna-microprep-plus-kit":	214306,
    "/products/quick-dna-rna-miniprep-plus-kit":	205893,
    "/products/quick-dna-rna-pathogen-miniprep":	214316,
    "/products/quick-dna-rna-viral-kit":	214308,
    "/products/quick-dna-ffpe-miniprep":	214288,
    "/products/quick-dna-fecal-soil-microbe-microprep":	214300,
    "/products/quick-dna-fecal-soil-microbe-dna-miniprep-kit":	205889,
    "/products/quick-dna-fungal-bacterial-microprep-kit":	214296,
    "/products/quick-dna-fungal-bacterial-miniprep-kit":	205864,
    "/products/quick-dna-hmw-magbead-kit":	219568,
    "/products/quick-dna-microprep":	214287,
    "/products/quick-dna-miniprep-plus-kit":	205791,
    "/products/quick-dna-plant-seed-96-kit":	224084,
    "/products/quick-dna-plant-seed-miniprep-kit":	214302,
    "/products/quick-dna-tissue-insect-miniprep-kit":	214301,
    "/products/quick-dna-urine-kit":	205817,
    "/products/quick-dna-viral-kit":	214286,
    "/products/quick-dna-microprep-plus-kit":	214291,
    "/products/quick-rna-96-kit":	217373,
    "/products/quick-rna-fecal-soil-microbe-microprep-kit":	224927,
    "/products/quick-rna-plant-kit":	224850,
    "/products/quick-rna-tissue-insect-kit":	220483,
    "/products/quick-rna-microprep-kit":	205862,
    "/products/quick-rna-ffpe-miniprep":	214312,
    "/products/quick-rna-miniprep-kit":	205863,
    "/products/quick-rna-whole-blood":	205877,
    "/products/quick-cfdna-rna-serum-plasma-kit":	214318,
    "/products/quick-cfdna-serum-plasma-kit":	205876,
    "/products/quick-cfrna-serum-plasma-kit":	214317,
    "/products/rna-clean-concentrator-25":	205885,
    "/products/rna-clean-concentrator-5":	205884,
    "/products/rna-wash-buffer":	217472,
    "/products/select-a-size-dna-clean-concentrator":	205843,
    // Below product's review is hidden per request from marketing, see Trello card #397 for details
    // "/products/select-a-size-dna-clean-concentrator-magbead-kit":	214292,
    "/products/strep-spin-protein-miniprep":	214310,
    "/products/tri-reagent":	217132,
    "/products/yeastar-genomic-dna-kit":	214285,
    "/products/yeastar-rna-kit":	214299,
    "/products/yeast-protein-kit":	214336,
    "/products/zr-bac-dna-miniprep-kit":	225768,
    "/products/dna-sequencing-clean-up":	214289,
    "/products/quick-rna-fungal-bacterial-miniprep-kit":	214326,
    "/products/quick-rna-plant-kit":	214327,
    "/products/zr-plasmid-miniprep-classic":	217329,
    "/products/quick-rna-fecal-soil-microbe-microprep-kit":	214329,
    "/products/quick-rna-tissue-insect-kit":	214328,
    "/products/zr-small-rna-page-recovery-kit":	225268,
    "/products/zr-96-dna-clean-amp-concentrator-5-deep-well":	217381,
    "/products/zymo-environ-water-rna-kit":	224048,
    "/products/zymo-seq-rrbs-library-kit":	225269,
    "/products/zymo-seq-ribofree-total-rna-library-kit":	217392,
    "/products/zymo-spin-ic-columns":	224851,
    "/products/zymo-spin-chip-kit":	205871,
    "/products/zymobiomics-96-dna-kit":	220908,
    "/products/zymobiomics-96-magbead-kit":	225274,
    "/products/zymobiomics-fecal-reference-trumatrix":	225174,
    "/products/zymobiomics-targeted-sequencing-service-16s":	224820,
    "/products/zymobiomics-gut-microbiome-standard":	225313,
    "/products/zymobiomics-microbial-community-dna-standard":	206031,
    "/products/zymobiomics-microbial-community-standard":	206030,
    "/products/zymobiomics-microbial-community-standard-ii-log-distribution":	214303,
    "/products/zymobiomics-pcr-premix":	206032,
    "/products/zymobiomics-spike-in-control-i-high-microbial-load":	214304,
    "/products/zymobiomics-dna-rna-miniprep-kit":	214325,
    "/products/zymobiomics-rna-miniprep-kit":	214324,
    "/products/zymopure-express-plasmid-midiprep-kit":	214294,
    "/products/zymopure-ii-plasmid-gigaprep-kit":	205860,
    "/products/zymopure-ii-plasmid-midiprep-kit":	205858,
    "/products/zymopure-ii-plasmid-miniprep-kit":	214293,
    "/products/zymotaq-dna-polymerase":	209454,
    "/products/zymoclean-gel-dna-recovery-kit":	81740,
    "/products/zymoclean-gel-rna-recovery-kit":	214314,
    "/products/zymoprep-yeast-plasmid-miniprep-ii":	205892,
    "/products/zyppy-plasmid-miniprep-kit":	92807,
    "/products/cfdna-cfrna-preservation-blood-tube":  2252380,
    "/products/dsdna-shearase-plus":	214297,
    "/products/ssdna-rna-clean-concentrator":	214307,
    "/products/dna-rna-shield-safecollect-saliva-collection-kit": 227127,
    "/products/dna-rna-shield-safecollect-swab-collection-kit": 227128,
  };

// checks to see if there are new reviews for products that are not yet included in selectScienceReviewsMapping
// $(document).ready(() => {
//     let newProductArray = [];

//     for (var i = 0; i < selectScienceReviewsJSON.reviews.length; i++) {
//         if (!Object.values(selectScienceReviewsMapping).includes(selectScienceReviewsJSON.reviews[i].productId)) {
//             newProductArray.push([selectScienceReviewsJSON.reviews[i].productId]);
//         }
//     }

//     console.log("productId does not exist:", newProductArray);
// })